import type { Settlement } from '@/models/settlements';
import {
  SettlementServiceApiFactory,
  type SettlementServiceApiSettlementServiceGetReportRequest,
} from '@layup/api-sdk';
import { API_URL } from '../config';
import { createLayupClient } from './layupApi';
import type { Writable } from './utils';

export type SettlementsServiceGetReportRequest = Writable<SettlementServiceApiSettlementServiceGetReportRequest>;

const settlementServiceClient = () => {
  const client = createLayupClient();
  return SettlementServiceApiFactory(undefined, undefined, client);
};

export const fetchSettlements = async (request: SettlementServiceApiSettlementServiceGetReportRequest) => {
  const response = await settlementServiceClient().settlementServiceGetReport(request);
  return response.data;
};

// No type in SDK
export const fetchSettlementById = async (id: string): Promise<Settlement> => {
  const client = createLayupClient(true, true);
  const response = await client.get(`v2/settlements/${id}?report=true`);
  return response.data as Settlement;
};

// Return the API endpoint URL directly - the browser will follow the redirect
// This avoids CORS issues with S3 pre-signed URLs
export const fetchSettlementFileLink = async (reference: string): Promise<string> => {
  return `${API_URL}/v3/settlements/files/${reference}`;
};
